// Template Generated by DataExtraction.py at 1721347791

import RestrictedClientEn1 from "../../Forms/Restricted Client/RestrictedClient_En1.png";
import RestrictedClientEn1Labels from "../../Labels/Restricted Client/RestrictedClient_En1.json";
import RestrictedClientFr1 from "../../Forms/Restricted Client/RestrictedClient_Fr1.png";
import RestrictedClientFr1Labels from "../../Labels/Restricted Client/RestrictedClient_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RestrictedClientFr1Labels : RestrictedClientEn1Labels;
    const formImage = isFrench ? RestrictedClientFr1 : RestrictedClientEn1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary
     */

    const common = data.common;

    let now = moment().format("YYYY-MM-DD");

    let text = "";

    const agent = authStatus.user.agentCodes.find((ac) => ac.code === data.common.agentCode);

    if (authStatus && authStatus.user && agent) {
        text = agent.restrictedClient;
    }

    // Drawing the form
    // TODO implement fields
    drawLongText(text, "restrictedClientText");
    drawText(now, "sub1SignDate");

    if (common.subscriber2Include) {
        drawText(now, "sub2SignDate");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? RestrictedClientFr1Labels : RestrictedClientEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const common = state.common;

    if (common.subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))], // TODO MUST check if signer is correct!
        });
    }


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))], // TODO MUST check if signer is correct!
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
